// extracted by mini-css-extract-plugin
export default {"root":"Glossary_root__1r-Q3","header":"Glossary_header__-cSkZ","switchContainer":"Glossary_switchContainer__24Us3"};